module.exports = __webpack_public_path__ + "static/media/jg.6abd4dad.png";